(function(Drupal) {
  // Check for any images within the .field--name-body class and check the height of the figcaption if it has it
  Drupal.behaviors.image_caption = {
    attach: function(context, settings) {
      document.querySelectorAll('.field--name-body .caption').forEach(function(captionImage) {
        if (!captionImage.querySelector('figcaption')) {
          return; // Skip if no figcaption is found
        }
        // Find the figcaption element
        var captionHeight = captionImage.querySelector('figcaption').clientHeight;
        captionImage.querySelector('figcaption').setAttribute('data-height', captionHeight);

        if (captionHeight > 30) {
          captionImage.classList.add('expandable');
          // Add clientHeight to captionImage.querySelector('figcaption') as a data attribute
          // Add a button to expand the caption
          var expandButton = document.createElement('button');
          expandButton.innerHTML = 'More';
          expandButton.addEventListener('click', function() {
            captionImage.classList.toggle('expanded');
            expandButton.innerHTML = captionImage.classList.contains('expanded') ? 'Less' : 'More';
            captionImage.querySelector('figcaption').style.height = captionImage.classList.contains('expanded') ? (captionHeight + 16) + 'px' : '24px';
          });
          captionImage.appendChild(expandButton);
        }
      });

      function syncImageAltWithCaption(maxLength = 125) {
        document.querySelectorAll('.caption-drupal-media').forEach(figure => {
          const img = figure.querySelector('img');
          const caption = figure.querySelector('figcaption');

          if (img && caption) {
            let captionText = caption.textContent.trim();

            if (captionText) {
              // Truncate if too long
              if (captionText.length > maxLength) {
                captionText = captionText.substring(0, maxLength - 1).trim() + '…';
              }
              img.alt = captionText;
            }
          }
        });
      }

      function handleHeroImageAlt(maxLength = 125) {
        document.querySelectorAll('figure.media--view-mode--hero').forEach(figure => {
          const img = figure.querySelector('img');

          if (img && img.alt) {
            const altText = img.alt.trim();

            if (altText.length > maxLength) {
              // Create figcaption with the full alt text
              const figcaption = document.createElement('figcaption');
              figcaption.textContent = altText;
              figure.appendChild(figcaption);

              // Truncate the alt text for accessibility
              img.alt = altText.substring(0, maxLength - 1).trim() + '…';
            }
          }
        });
      }


      syncImageAltWithCaption();
      handleHeroImageAlt();
    }
  };
})(Drupal);